import styled from '@emotion/styled';
import { useLingui } from '@lingui/react/macro';
import type { LayoutPreset } from 'modules/manager/domain/layout-blocks';
import React from 'react';
import UDModal from 'ud-ui/components/modal';
import LayoutPresetCard from './layout-preset-card';

interface LayoutBlocksModalProps {
  show: boolean;
  onClose: () => void;
  presets: LayoutPreset[];
  currentPresetId?: string;
  onPick: (presetId: string) => void;
}

const LayoutBlocksModal: React.FC<LayoutBlocksModalProps> = ({ show, onClose, presets, currentPresetId, onPick }) => {
  const { t } = useLingui();
  return (
    <UDModal show={show} onClose={onClose} size="lg">
      <UDModal.Header title={t`Выберите макет`} />
      <UDModal.Body>
        <Grid>
          {presets.map((preset) => (
            <LayoutPresetCard
              key={preset.id}
              preset={preset}
              selected={preset.id === currentPresetId}
              onClick={() => {
                onPick(preset.id);
                onClose();
              }}
            />
          ))}
        </Grid>
      </UDModal.Body>
    </UDModal>
  );
};

export default React.memo(LayoutBlocksModal);

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;

  @media (max-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
